import { Spin } from 'antd';

export default function AppLoader({}) {
  return <Spin size="large" style={{ width: '100%', marginTop: '20vh' }} />;
}
